// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Ahmed Hosny

import type { Icon } from 'iconsax-react';

const MoreHorizontalIcon: Icon = ({ size = 24, color, variant: _variant, className, style, ...rest }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      {...rest}
    >
      <path d="M12.0004 13.5984C11.1044 13.5984 10.4004 12.8784 10.4004 11.9984C10.4004 11.1184 11.1204 10.3984 12.0004 10.3984C12.8804 10.3984 13.6004 11.1184 13.6004 11.9984C13.6004 12.8784 12.8964 13.5984 12.0004 13.5984Z" fill={color || 'currentColor'} />
      <path d="M18.4008 13.5984C17.5048 13.5984 16.8008 12.8784 16.8008 11.9984C16.8008 11.1184 17.5208 10.3984 18.4008 10.3984C19.2808 10.3984 20.0008 11.1184 20.0008 11.9984C20.0008 12.8784 19.2968 13.5984 18.4008 13.5984Z" fill={color || 'currentColor'} />
      <path d="M5.6 13.5984C4.704 13.5984 4 12.8784 4 11.9984C4 11.1184 4.72 10.3984 5.6 10.3984C6.48 10.3984 7.2 11.1184 7.2 11.9984C7.2 12.8784 6.496 13.5984 5.6 13.5984Z" fill={color || 'currentColor'} />
    </svg>
  );
};

export { MoreHorizontalIcon };
